export default {
  colors: {
    primary: '#B22938',
  },
  forms: {
    horizontalGutterInPx: 16,
  },
};
